import { IOrderParams } from '../../../../../API/pcDashboard/getOrderAsync';
import React, { useCallback, useEffect, useState } from 'react';

export interface SigningAppointmentsPaginationSortParams {
  sortBy: string;
  pageNumber: number;
  pageSize: number;
}

const defaultPaginationSortParams: SigningAppointmentsPaginationSortParams = {
  sortBy: 'scheduledFor.desc',
  pageNumber: 0,
  pageSize: 20,
};

/**
 * Hook that manages the state of the signing appointments table's pagination and sort settings.
 * This is an extension of the tasks table pagination hook.
 * When the queryWithoutPagination prop changes, it resets the paginationSortParams back to the default.
 * @param queryWithoutPagination - the properties of the query that do not include pagination, sort, or sortProperty
 */
export const useManageSigningAppointmentsPagination = (
  queryWithoutPagination: Omit<IOrderParams, 'pageNumber' | 'pageSize' | 'sortBy'>
): {
  paginationState: [
    SigningAppointmentsPaginationSortParams,
    React.Dispatch<React.SetStateAction<SigningAppointmentsPaginationSortParams>>,
  ];
  revertToFirstPage: () => void;
} => {
  const [paginationSortParams, setPaginationSortParams] =
    useState<SigningAppointmentsPaginationSortParams>(defaultPaginationSortParams);
  useEffect(() => {
    setPaginationSortParams(defaultPaginationSortParams);
  }, [queryWithoutPagination]);
  const revertToFirstPage = useCallback(() => {
    setPaginationSortParams(defaultPaginationSortParams);
  }, []);

  return { paginationState: [paginationSortParams, setPaginationSortParams], revertToFirstPage };
};
